import React, { FC, ReactElement } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { CircularProgressProps, Theme } from '@mui/material';
import { clsx } from 'clsx';
// Components
import Loader from './loader';
import Text from './text';
import SvgIcon from './icons/SvgIcon';
import { IconLogo } from '../resources/images';

interface LoaderFullPageProps {
    msg?: string;
    withIcon?: boolean;
    backgroundColor?: 'lightblue';
    color?: CircularProgressProps['color'];
}

const LoaderFullPage: FC<LoaderFullPageProps> = ({
    color = 'secondary',
    withIcon = false,
    msg,
    backgroundColor,
}): ReactElement => {
    const classes = useStyles();

    return (
        <div className={clsx(classes.loadingContainer, backgroundColor && classes[backgroundColor])}>
            <div className={classes.loading}>
                {withIcon && (
                    <SvgIcon icon={IconLogo.Logo} size="inherit" stroke="unset" overwritePathFill fill="white" />
                )}
                <Loader noFlex color={color} />
                {msg && <Text.Description14 text={msg} customColor="lightblue" />}
            </div>
        </div>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        loadingContainer: {
            height: '100dvh',
        },
        loading: {
            display: 'flex',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            rowGap: 10,
        },
        lightblue: {
            backgroundColor: theme.palette.secondary.light,
            '& .MuiCircularProgress-svg': {
                color: 'white',
            },
            '& .MuiTypography-body1': {
                color: 'white',
            },
        },
    }),
);

export default LoaderFullPage;
